import { loadStripe } from '@stripe/stripe-js'
import { supabase } from './supabase'

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY

if (!stripePublishableKey) {
  console.warn('Stripe publishable key not found. Please set VITE_STRIPE_PUBLISHABLE_KEY in .env file.')
}

let stripePromise
const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(stripePublishableKey || '')
  }
  return stripePromise
}

export const stripe = {
  // Create checkout session for subscription
  async createCheckoutSession(priceId, userId) {
    try {
      // Call Supabase Edge Function to create checkout session
      const { data, error } = await supabase.functions.invoke('create-checkout-session', {
        body: {
          priceId,
          userId,
          successUrl: `${window.location.origin}/account?session_id={CHECKOUT_SESSION_ID}`,
          cancelUrl: `${window.location.origin}/shop`,
        },
      })
      
      if (error) throw error
      
      // Redirect to Stripe Checkout
      const stripe = await getStripe()
      const { error: stripeError } = await stripe.redirectToCheckout({
        sessionId: data.sessionId,
      })
      
      if (stripeError) throw stripeError
    } catch (error) {
      console.error('Checkout error:', error)
      throw error
    }
  },
  
  // Create portal session for subscription management
  async createPortalSession(userId) {
    try {
      const { data, error } = await supabase.functions.invoke('create-portal-session', {
        body: {
          userId,
          returnUrl: `${window.location.origin}/account`,
        },
      })
      
      if (error) throw error
      
      // Redirect to Stripe Customer Portal
      window.location.href = data.url
    } catch (error) {
      console.error('Portal error:', error)
      throw error
    }
  },
  
  // Purchase item with one-time payment
  async purchaseItem(itemId, amount, userId) {
    try {
      const { data, error } = await supabase.functions.invoke('create-payment-intent', {
        body: {
          itemId,
          amount,
          userId,
        },
      })
      
      if (error) throw error
      
      const stripe = await getStripe()
      const { error: stripeError } = await stripe.confirmCardPayment(data.clientSecret)
      
      if (stripeError) throw stripeError
      
      return { success: true }
    } catch (error) {
      console.error('Purchase error:', error)
      throw error
    }
  },
}

export default stripe
